import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=578e421b&functional=true"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578e421b')) {
      api.createRecord('578e421b', component.options)
    } else {
      api.rerender('578e421b', component.options)
    }
    module.hot.accept("./FormGroup.vue?vue&type=template&id=578e421b&functional=true", function () {
      api.rerender('578e421b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/FormGroup.vue"
export default component.exports